import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { QuoteMediaSp500ListsTable } from '../../../../../../../../../../features/vendor/quotemedia/sp500-list/quotemedia-sp500-lists-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/quote-media/sp-500/_sp-500/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorQuoteMedia,
      label: 'S&P 500 Lists',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorQuoteMedia>,
  head: () => getPageHead('QuoteMedia S&P 500 Lists'),
  component: QuoteMediaSp500ListsList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingVendorQuoteMedia}
    />
  );
}

function QuoteMediaSp500ListsList() {
  return (
    <PageLayout>
      <PageLayout.Section>
        <QuoteMediaSp500ListsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
